
import * as React from 'react';
import EditorProps from '../editorinterface';
import SelectEditor from '../selecteditor';
import TextEditor from '../texteditor';
import { EnumColor } from '../../store/types';
import './index.css';

interface CondEnumForeignEditorProps extends EditorProps {
    foreignValue : string | null;
}

//jndp code review: Quand on clique sur une autre valeur depuis le select lié et que ça 
//efface le contenu de CondEnumForeignEditor la nouvelle valeur de CondEnumForeignEditor n'est 
//pas sauvegardé. Du coup le store contient toujours l'ancienne valeur inchangée. Je propose
//soit de desactivé cette fonctionnalité, soit d'agir directement dans le store pour faire
//en sorte que lorsqu'on modifie un select qui a des condselect lié, on mette automatiquement
//tous ces condselect lié à jour. De cette façon, les valeurs affichés restent synchro avec le store
class CondEnumForeignEditor extends React.Component<CondEnumForeignEditorProps> {

  constructor(props: CondEnumForeignEditorProps) {
    super(props);
  }

  render() {
      const textField = {
          id: this.props.field.id,
          name: this.props.field.name,
          type: 'texteditor',
          readOnly: this.props.field.readOnly
      }
      const selectProps = this.generateSelectEditorProps();
    return (
        selectProps ?
          (<SelectEditor {...selectProps}/>) :
          (<TextEditor
              onChange={this.props.onChange}
              value={this.props.value}
              field={textField}
          />)
    );
  }

  private generateSelectEditorProps() {
      const { id, name, type, readOnly } = this.props.field;
      const enumColors = (this.props.foreignValue !== null) ? this.props.field.condEnumColors[this.props.foreignValue] : null;
      if(!enumColors) {
        return null;
      }
      const field = { id, name, type, readOnly, enumColors};
      const value = (valueExistsInEnumColors(enumColors, this.props.value)) ? this.props.value : '';
      const onChange = this.props.onChange;
      const props : EditorProps = { onChange, field, value };
      return props;
  }

}

const valueExistsInEnumColors = (enumColors: EnumColor, value: string) : boolean => {
    const values = enumColors.values;
    for (let index in values) {
        if (values[index].value === value)
            return true;
    }
    return false;
}

export default CondEnumForeignEditor;



// WEBPACK FOOTER //
// ./src/components/condenumforeigneditor/index.tsx